import { combineReducers } from 'redux';
import { sliderDialogReducer } from './Reducers/sliderDialogReducer';
import { headerReducer } from './Reducers/headerReducer';
import { userReducer } from './Reducers/userReducer';
import { sideBarReducer } from './Reducers/sideBarReducer';
import { moduleReducer } from './Reducers/moduleReducer';

const appReducer = combineReducers({
  sliderDialogReducer,
  headerReducer,
  userReducer,
  sideBarReducer,
  moduleReducer
});

export const reducers = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};
